// extracted by mini-css-extract-plugin
export default {"chargesAddContainer":"AssignCharge_chargesAddContainer__du1tg","selectionContainer":"AssignCharge_selectionContainer__Ji4RP","submitButton":"AssignCharge_submitButton__dBZqd"};